import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../../hooks'
import { performMockImportRunReprocess } from '../../IntegrationsImportLog.mocks'

export function useIntegrationsReprocess({ onReprocessed }) {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const [reprocessedRun, setReprocessedRun] = useState(null)

  function handleStartReprocess(run) {
    setReprocessedRun(run)
  }

  function handleCancelReprocess() {
    setReprocessedRun(null)
  }

  async function handleConfirmReprocess() {
    return performMockImportRunReprocess(reprocessedRun.id)
      .then(() => {
        setReprocessedRun(null)

        handleAddSuccessNotification({
          title: t('RentalPortal.IntegrationsRunReprocessStartedKey'),
        })

        onReprocessed()
      })
      .catch(() => {
        setReprocessedRun(null)

        handleAddErrorNotification({
          title: t('RentalPortal.IntegrationsRunReprocessErrorKey'),
        })
      })
  }

  return {
    handleCancelReprocess,
    handleConfirmReprocess,
    handleStartReprocess,
    reprocessedRun,
  }
}
